var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M6 11.25A5.25 5.25 0 1 1 6 .75a5.25 5.25 0 0 1 0 10.5M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M3.485 3.485a.375.375 0 0 1 .53 0L6 5.47l1.985-1.985a.375.375 0 0 1 .53.53L6.53 6l1.985 1.985a.375.375 0 0 1-.53.53L6 6.53 4.015 8.515a.375.375 0 1 1-.53-.53L5.47 6 3.485 4.015a.375.375 0 0 1 0-.53"
  })));
};
export default SvgXCircle;